import React from "react";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles(theme => ({
  "@global": {
    a: {
      color: theme.palette.primary.main,
      textDecoration: "underline"
    },
    /* CK Editor Styles */
    ".repository-item-link": {
      color: theme.palette.primary.main
    },
    ".repository-item-link:hover": {
      backgroundColor: theme.palette.action.hover
    }
  }
}));

const ThemeWrapper = ({ children }) => {
  useStyles();
  return <div>{children}</div>;
};

export default ThemeWrapper;
